/* eslint-disable */
export const SET_REQUEST_STATUS = 'SET_REQUEST_STATUS';
